import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Search, X } from "lucide-react";

export const CustomerPickerField = ({ API, value, onChange, testId }) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  useEffect(() => {
    if (!query.trim()) { setResults([]); return; }
    const t = setTimeout(() => {
      axios.get(`${API}/org/support/customers`, { params: { search: query }, withCredentials: true })
        .then(({ data }) => setResults(data.customers)).catch(() => setResults([]));
    }, 250);
    return () => clearTimeout(t);
  }, [API, query]);

  if (value) {
    return (
      <div className="flex items-center justify-between rounded-lg border border-slate-200 px-3 py-2 text-sm dark:border-white/15 dark:bg-[#0B1220]" data-testid={testId}>
        <span className="font-semibold text-slate-900 dark:text-white">{value.first_name} {value.last_name} {value.email ? `· ${value.email}` : ""}</span>
        <button type="button" onClick={() => onChange(null)} data-testid={`${testId}-clear`} className="text-slate-400 hover:text-slate-700 dark:hover:text-white"><X size={14} /></button>
      </div>
    );
  }

  return (
    <div className="relative" ref={boxRef}>
      <div className="relative">
        <Search size={14} className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <input
          value={query}
          onChange={(e) => { setQuery(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)}
          placeholder="Search customer by name, email or phone…"
          data-testid={testId}
          className="w-full rounded-lg border border-slate-200 py-2 pl-8 pr-3 text-sm dark:border-white/15 dark:bg-[#0B1220] dark:text-white"
        />
      </div>
      {open && (
        <div className="absolute z-20 mt-1 w-full overflow-hidden rounded-lg border border-slate-200 bg-white shadow-lg dark:border-white/15 dark:bg-[#111C33]" data-testid={`${testId}-results`}>
          {results.length === 0 ? (
            query.trim() && <p className="px-3 py-2 text-xs text-slate-400" data-testid={`${testId}-no-results`}>No customers found.</p>
          ) : results.map((c) => (
            <button
              key={c.customer_id}
              type="button"
              onClick={() => { onChange(c); setOpen(false); setQuery(""); }}
              data-testid={`${testId}-result-${c.customer_id}`}
              className="block w-full px-3 py-2 text-left text-sm hover:bg-slate-50 dark:hover:bg-white/10"
            >
              <span className="font-semibold text-slate-900 dark:text-white">{c.first_name} {c.last_name}</span>
              <span className="ml-1 text-xs text-slate-400">{c.email || c.phone}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
